
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import {
  SanityDocumentSchema,
  ISanityDocuments,
} from '~/types/sanity-documents';
import SanityReference from '~/components/Sanity/SanityReference.vue';

interface IIcon {
  title: string;
  titleAbbrev: string;
  _type: SanityDocumentSchema;
}

@Component({
  components: {
    SanityReference,
  },
})
export default class FilmOverview extends Vue {
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.FILM];

  schemas = SanityDocumentSchema;

  get genres() {
    return this.doc?.genres || [];
  }

  get icons(): { _id: string; _type: SanityDocumentSchema }[] {
    const icons = new Map<
      string,
      { _id: string; _type: SanityDocumentSchema }
    >();

    if (!this.mainContent) {
      return [];
    }

    const content = this.mainContent;
    if (content.contentRating?.rating?._ref) {
      icons.set(content.contentRating.rating._ref as string, {
        _id: content.contentRating.rating._ref as string,
        _type: this.schemas.RATING,
      });
    }
    if (content.maxResolution?._ref) {
      icons.set(content.maxResolution._ref as string, {
        _id: content.maxResolution._ref as string,
        _type: this.schemas.RESOLUTION,
      });
    }

    if (content.transcripts) {
      content.transcripts.forEach((transcript) => {
        if (!transcript.type?._ref) {
          return;
        }
        if (!icons.has(transcript.type._ref as string)) {
          icons.set(transcript.type._ref as string, {
            _id: transcript.type._ref as string,
            _type: this.schemas.TRANSCRIPT_TYPE,
          });
        }
      });
    }

    return [...icons.values()];
  }

  get mainContent(): ISanityDocuments[SanityDocumentSchema.VIDEO] | undefined {
    if (!this.doc?.content?._ref) {
      return;
    }

    return this.$sanityLookup.getDocumentFromId({
      _id: this.doc.content._ref,
      _type: this.schemas.VIDEO,
    })?.data as ISanityDocuments[SanityDocumentSchema.VIDEO];
  }

  get releaseYear() {
    const dateString = this.doc?.releaseDate || '';

    if (!dateString) {
      return '';
    }

    return format(parseISO(dateString), 'Y');
  }

  get runTime() {
    if (!this.mainContent?.runTime) {
      return null;
    }

    return this.mainContent.runTime;
  }

  getIconClasses(icon: IIcon) {
    return {
      'd-block film-icon font-weight-bold py-1 mx-2 my-1': true,
      'rounded-circle': icon.titleAbbrev?.length === 1,
      'rounded px-2': icon.titleAbbrev?.length > 1,
      'accentGrayLight--text': icon._type !== this.schemas.RESOLUTION,
      'black--text accentGrayLight': icon._type === this.schemas.RESOLUTION,
      'has-tooltip': !!icon.title,
    };
  }
}
